import { Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import { VerticalAlignGrid } from "../../../invoices/styled";
import {
  INVOICE_BREAKDOWN_OPTIONS,
  INVOICE_FORMAT_OPTIONS,
  invoiceSeparationOptions,
} from "../constants";
import { useContractDataContext } from "../ContractDataProvider";
import LabelSelectRow from "./LabelSelectRow";

const InvoicingDetailsSection = () => {
  const { t } = useTranslation("customers");
  const { paymentTermOptions, salesAccountsOptions, salesAccountsObject } =
    useContractDataContext();
  const { getValues } = useFormContext();

  return (
    <FormSection title={t("contract.invoicingDetails")}>
      <VerticalAlignGrid item container spacing={2} xs={11}>
        <Grid item xs={3} />
        <Grid item xs={8}>
          <Typography variant="secondary">
            {t("contract.invoicingGuideText")}
          </Typography>
        </Grid>
      </VerticalAlignGrid>
      <LabelSelectRow
        label={t("contract.paymentTerm")}
        fieldName="paymentTermDays"
        options={
          paymentTermOptions.length > 0
            ? paymentTermOptions.map((paymentTerm) =>
                paymentTerm.days.toString(),
              )
            : [getValues("paymentTermDays")]
        }
        getDisplayValue={(val) =>
          val ? t("contract.days", { number: val }) : ""
        }
        selectWidth={3}
      />
      <LabelSelectRow
        required
        label={t("contract.invoicesSeparation")}
        fieldName="invoicesSeparation"
        options={invoiceSeparationOptions}
        getDisplayValue={(val) => (val ? t(`contract.${val}`) : "")}
        selectWidth={3}
        showTooltip
        tooltipText={t("contract.invoicesSeparationTooltip")}
      />
      <LabelSelectRow
        label={t("contract.invoiceFormat")}
        fieldName="invoiceFormat"
        options={INVOICE_FORMAT_OPTIONS}
        getDisplayValue={(val) => (val ? t(`contract.${val}`) : "")}
        showTooltip
        tooltipText={t("contract.invoiceFormatTooltip")}
      />
      <LabelSelectRow
        label={t("contract.invoiceBreakdown")}
        fieldName="invoiceBreakdown"
        options={INVOICE_BREAKDOWN_OPTIONS}
        getDisplayValue={(val) => t(`contract.${val}`)}
        multiple
        multipleEmptyValue={t("contract.noBreakdown")}
        showTooltip
        tooltipText={t("contract.invoiceBreakdownTooltip")}
      />
      <LabelSelectRow
        label={t("contract.accountingOfInvoicing")}
        fieldName="salesAccountCode"
        options={
          salesAccountsOptions.length > 0
            ? salesAccountsOptions.map((account) => `${account.code}`)
            : [getValues("salesAccountCode")]
        }
        getDisplayValue={(code: string) =>
          `${code} ${salesAccountsObject[code]?.description || ""}`
        }
        showTooltip
        tooltipText={t("contract.accountingOfInvoicingTooltip")}
      />
    </FormSection>
  );
};

export default InvoicingDetailsSection;
